import Pauta from '../components/Pauta';

export default function PautaFinalizado() {
  return <Pauta statusPauta="Finalizado" colunas={['Pgto NF', 'Pgto Custas']} corPauta="#388e3c" />;
}